import { render, staticRenderFns } from "./DefaultTheme.vue?vue&type=template&id=7e98f100"
import script from "./DefaultTheme.vue?vue&type=script&lang=ts"
export * from "./DefaultTheme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports